export const identity = <T>(x: T) => x;
